import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
export const FolderThemeOpenIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "FolderThemeOpen",
    children: /*#__PURE__*/_jsx("path", {
      d: "M26.61 10.67h-7.32c-.21 0-.39-.13-.46-.33l-1.05-3.16a3.41 3.41 0 0 0-3.21-2.32h-3.02c-1.44 0-2.73.91-3.21 2.27L7.2 10.59l-.49-.33c-.52-.44-1.17-.68-1.85-.68-1.57 0-2.86 1.26-2.87 2.83 0 .82.34 1.6.95 2.14.21.17.44.32.68.44l1.05.68c-.62.33-.92 1.06-.7 1.73l2.87 8.73c.2.59.75.99 1.37.99H26.6c1.87 0 3.39-1.52 3.39-3.39v-9.7c0-1.87-1.52-3.38-3.39-3.38ZM4.09 14.13c-.17-.08-.32-.18-.46-.31a1.86 1.86 0 0 1-.31-2.61 1.86 1.86 0 0 1 2.79-.15l10.51 6.91-1.99 3.06-10.55-6.9Zm12.7 7.78c-.2.3-.6.39-.91.19a.63.63 0 0 1-.29-.42c-.03-.17 0-.35.1-.5l1.42-2.19c.1-.15.25-.26.43-.29.36-.07.7.15.78.51.03.17 0 .35-.1.5l-1.43 2.19Zm6.57 3.19h-.05c-.29.03-.58.05-.86.05h-.06c-.62.02-1.24-.03-1.85-.13h-.05c-.34-.05-.68-.14-1-.25-1.98-.66-2.14-2.59-.86-3.93s3.15-.45 3.78 1.56c.12.43.34.83.66 1.16.1.11.22.2.35.26.24.07.41.26.47.5.06.35-.16.69-.51.77v.02Zm2.77-.86h-.11a.99.99 0 0 1-.79-.68l-.78-2.34-1.9-5.7h-7.91l-2.92-1.93h11.47c.41 0 .78.26.92.66l.45 1.34 1.17 3.53 1.31 3.84c.04.1.05.2.05.3 0 .53-.43.97-.97.97h-.04l.03.02Z"
    })
  }));
};